// Логотип компании «Code.Flow». Тёмная часть знака подстраивается под тему
// через currentColor, фирменный оранжевый — фиксированный цвет марки.
type LogoProps = {
  variant?: 'full' | 'mark';
  className?: string;
};

export function Logo({ variant = 'full', className }: LogoProps) {
  if (variant === 'mark') {
    // компактное начертание — только первая буква «C», урезанный по ширине viewBox
    return (
      <svg className={className} viewBox="0 -2.2 88.26 104.4" role="img" aria-label="Code.Flow">
        <path fill="currentColor" d="M88.26 22.01A48 51.4 0 1 0 88.26 77.99L65.19 66.28A20.5 29.9 0 1 1 65.19 33.72Z" />
      </svg>
    );
  }
  return (
    <svg className={className} viewBox="0 -2.2 1050.56 104.4" role="img" aria-label="Code.Flow">
      <path
        fill="currentColor"
        d="M88.26 22.01A48 51.4 0 1 0 88.26 77.99L65.19 66.28A20.5 29.9 0 1 1 65.19 33.72Z M115.46 50A55.5 52.2 0 1 1 226.46 50A55.5 52.2 0 1 1 115.46 50Z M142.96 50A28 30.7 0 1 0 198.96 50A28 30.7 0 1 0 142.96 50Z M259.06 0L303.06 0A51.5 50 0 0 1 303.06 100L259.06 100Z M284.56 79L303.06 79A24 29 0 0 0 303.06 21L284.56 21Z M387.16 0L412.66 0L412.66 100L387.16 100Z M406.66 0L455.26 0L455.26 21L406.66 21Z M406.66 39.5L452.26 39.5L452.26 57.5L406.66 57.5Z M406.66 79L461.76 79L461.76 100L406.66 100Z"
      />
      <path fill="#EE7D34" d="M504.76 87.25A12.75 12.75 0 1 1 530.26 87.25A12.75 12.75 0 1 1 504.76 87.25Z" />
      <path
        fill="#EE7D34"
        d="M573.26 0L598.76 0L598.76 100L573.26 100Z M592.76 0L641.36 0L641.36 21L592.76 21Z M592.76 39.5L638.36 39.5L638.36 57.5L592.76 57.5Z M679.36 0L704.86 0L704.86 100L679.36 100Z M698.86 79L750.36 79L750.36 100L698.86 100Z M774.96 50A55.5 52.2 0 1 1 885.96 50A55.5 52.2 0 1 1 774.96 50Z M802.46 50A28 30.7 0 1 0 858.46 50A28 30.7 0 1 0 802.46 50Z M912.56 0L939.56 0L953.38 34.55L968.06 0L995.06 0L1009.74 34.55L1023.56 0L1050.56 0L1010.56 100L981.56 31.76L952.56 100Z"
      />
    </svg>
  );
}
